import React from "react";
import "./Terms.css";

export default function Cookies() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Cookie Policy</h1>
          <p className="last-updated">Last Updated: January 2024</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your device when you visit our website. 
              They help us provide you with a better experience by remembering your preferences and 
              understanding how you use our platform.
            </p>
          </section>

          <section>
            <h2>Types of Cookies We Use</h2>
            
            <h3>Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable core 
              functionality such as security, authentication, and maintaining your session.
            </p>

            <h3>Performance Cookies</h3>
            <p>
              These cookies help us understand how visitors interact with our website by collecting 
              and reporting information anonymously. This helps us improve our platform.
            </p>

            <h3>Functionality Cookies</h3>
            <p>
              These cookies allow the website to remember choices you make (such as your username, 
              language, or region) and provide enhanced, personalized features.
            </p>

            <h3>Targeting/Advertising Cookies</h3>
            <p>
              These cookies may be set through our site by our advertising partners. They may be used 
              to build a profile of your interests and show you relevant content.
            </p>
          </section>

          <section>
            <h2>How We Use Cookies</h2>
            <p>We use cookies to:</p>
            <ul>
              <li>Keep you signed in to your account</li>
              <li>Remember your preferences and settings</li>
              <li>Understand how you use our platform</li>
              <li>Improve website performance and user experience</li>
              <li>Provide personalized content and recommendations</li>
              <li>Deliver relevant advertisements</li>
              <li>Protect against fraudulent activity</li>
            </ul>
          </section>

          <section>
            <h2>Managing Cookies</h2>
            <p>
              You can control and manage cookies in various ways. Please note that removing or blocking 
              cookies may impact your user experience and some features may no longer function properly.
            </p>

            <h3>Browser Settings</h3>
            <p>
              Most browsers allow you to control cookies through their settings. You can typically find 
              these settings in the "Options" or "Preferences" menu of your browser.
            </p>

            <h3>Third-Party Tools</h3>
            <p>
              You can opt out of third-party advertising cookies through industry opt-out pages such as:
            </p>
            <ul>
              <li>Network Advertising Initiative (NAI) - www.networkadvertising.org/choices/</li>
              <li>Digital Advertising Alliance (DAA) - www.aboutads.info/choices/</li>
              <li>European Digital Advertising Alliance (EDAA) - www.youronlinechoices.eu/</li>
            </ul>
          </section>

          <section>
            <h2>Cookies Used on Our Site</h2>
            <p>Below is a list of cookies we commonly use:</p>
            <ul>
              <li><strong>session_id:</strong> Essential - Maintains your login session</li>
              <li><strong>user_preferences:</strong> Functionality - Remembers your settings</li>
              <li><strong>analytics_token:</strong> Performance - Helps us analyze site usage</li>
              <li><strong>consent_status:</strong> Essential - Remembers your cookie preferences</li>
            </ul>
          </section>

          <section>
            <h2>Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in technology, 
              legislation, or our business operations. We will notify you of any significant changes 
              by posting the new policy on this page.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have questions about our use of cookies, please contact us:
            </p>
            <p className="contact-info">
              Email: privacy@gowithmebuddy.com<br />
              Address: Gurgaon, Haryana
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
